import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import Recaptcha from 'formvalidation/es6/plugins/Recaptcha';
import Aria from 'formvalidation/es6/plugins/Aria';

export default function newsletterFormValidation() {
    const accessForm = document.querySelector('.section-form form');
    if (accessForm) {
        formValidation(accessForm, {
            plugins: {
                aria: new Aria(),
                trigger: new Trigger(),
                bootstrap3: new Bootstrap3(),
                defaultSubmit: new DefaultSubmit(),
                submitButton: new SubmitButton(),
                declarative: new Declarative({
                    html5Input: true,
                }),
                recaptcha: new Recaptcha({
                    element: 'paywall_captcha_container',
                    siteKey: process.env.INVISIBLE_RECAPTCHA_SITE_KEY,
                    size: 'invisible',
                    message: JSON.parse(document.querySelector('#json_translations').innerHTML).reCaptchaErrorMessage,
                }),
            },
        });
        const formControl = accessForm.querySelectorAll('input.form-control');
        [].forEach.call(formControl, (input) => {
            if (input.value !== '') {
                input.classList.add('not-empty');
                input.classList.remove('empty');
            }
            input.addEventListener('blur', function classOnBlur() {
                const tmpval = this.value;
                if (tmpval === '') {
                    this.classList.add('empty');
                    this.classList.remove('not-empty');
                } else {
                    this.classList.add('not-empty');
                    this.classList.remove('empty');
                }
            });
        });
    }
}
